import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";

import TextField from "@material-ui/core/TextField";
import {GreenButton, OrangeButton} from "../common/ButtonsConstants";
import {
    deletePositionDescriptions,
    positionDescriptions,
    saveOrUpdatePositionDescriptions
} from "../../util/ApiUtils";
import Typography from "@material-ui/core/Typography";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    'input': {
    '&::placeholder': {
        textOverflow: 'ellipsis !important',
        background: 'yellow'
    }
},
}));

const columns = [
    /*{
        name: 'Identifier',
        id: 'identifier',
        type: "text",
    },*/
    {
        name: 'Job Title',
        id: 'jobTitle',
        type: "text",
    },
    {
        name: 'Location',
        id: 'location',
        type: "text",
    },
    {
        name: 'Supervisor/Manager',
        id: 'supervisor',
        type: "text",
    },
];

class PositionDescriptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            positionDescriptions: [],
            id: null,
            isLoading: true,
            isEditing: false,
            show: false,
            identifier: "",
            jobTitle: "",
            location: "",
            supervisor: "",
            duties: "",
            qualifications: "",
            experience: "",
            skills: "",
            performanceGoals: "",
        };
        this.loadPositionDescriptions = this.loadPositionDescriptions.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    componentDidMount() {
        this.loadPositionDescriptions();
    }

    loadPositionDescriptions() {
        positionDescriptions()
            .then(response => {
                console.log('review', response);
                this.setState({
                    positionDescriptions: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(jobDescrition) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: jobDescrition.id,
            header: `${jobDescrition.jobTitle}`,
            jobTitle: jobDescrition.jobTitle,
            location: jobDescrition.location,
            supervisor: jobDescrition.supervisor,
            duties: jobDescrition.duties,
            qualifications: jobDescrition.qualifications,
            experience: jobDescrition.experience,
            skills: jobDescrition.skills,
            performanceGoals: jobDescrition.performanceGoals,
        });
    }

    handleAddRow() {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            id: null,
            identifier: "",
            jobTitle: "",
            location: "",
            supervisor: "",
            duties: "",
            qualifications: "",
            experience: "",
            skills: "",
            performanceGoals: "",
            header: "New Record",
        })
    }

    reset() {
        this.setState({
            isEditing: false,
            isLoading: true,
            isNew: true,
            id: null,
            identifier: "",
            jobTitle: "",
            location: "",
            supervisor: "",
            duties: "",
            qualifications: "",
            experience: "",
            skills: "",
            performanceGoals: "",
            header: "New Record",
        });
        this.loadPositionDescriptions();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        deletePositionDescriptions(record)
            .then(() => {
                NotificationManager.success('Success', 'The Position Description record has been removed.', 5000);
                this.reset();
            }).catch(error => {
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        saveOrUpdatePositionDescriptions(this.state)
        .then((updatedRecord) => {
            NotificationManager.success('Success', 'The Position Description record has been updated.', 5000);
            this.reset();
        }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                POSITION DESCRIPTIONS
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                {(!state.isEditing ?
                        <div>
                            {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/position-descriptions/export')} style={{ float: 'right', marginRight: "160px" }}>EXPORT</GreenButton>}
                            <TableComponent
                                tableKey="positionDescriptionsTable"
                                data={state.positionDescriptions}
                                columns={columns}
                                handleSubmit={this.handleSubmit}
                                handleAddRow={this.handleAddRow}
                                handleRowDel={this.onDelete}
                                handleRowEdit={this.onEdit}
                                allowAdd={isAuditor ? 'disable' : 'show'}
                                allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                                pagination={true}
                            />
                        </div>
                        :
                        <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                            <div>
                                <TextField
                                    id="jobTitle"
                                    name="jobTitle"
                                    value={state.jobTitle}
                                    label="Job Title"
                                    onChange={this.handleTextChange}
                                    placeholder="<Role name> e.g. Receptionist, Sales assistant"
                                    style={{ width: "600px"}}
                                    InputProps={{classes: {input: this.props.classes['input']}}}
                                />
                            </div>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    id="location"
                                    name="location"
                                    value={state.location}
                                    label="Location"
                                    onChange={this.handleTextChange}
                                    style={{ width: "600px"}}
                                    placeholder="<The physical address that the employee will work at. If the job requires travel, state the primary location> e.g. Sydney  office"
                                    InputProps={{classes: {input: this.props.classes['input']}}}
                                />
                            </div>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    id="supervisor"
                                    name="supervisor"
                                    value={state.supervisor}
                                    label="Supervisor/Manager"
                                    onChange={this.handleTextChange}
                                    style={{ width: "600px"}}
                                    placeholder="<Who the employee will report to> e.g. Office Manager; Shift Supervisor"
                                    InputProps={{classes: {input: this.props.classes['input']}}}
                                />
                            </div>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    id="duties"
                                    name="duties"
                                    value={state.duties}
                                    label="MAIN DUTIES/RESPONSIBILITIES:"
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: "600px"}}
                                    placeholder="<Outline the duties and responsibilities of the position>&#13;&#10;
                                        - Coordinate and carry out all office administration including reception, mail, couriers, greeting clients and filing&#13;&#10;
                                        - Maintain a clean and safe workspace, and abide by workplace health and safety policies and procedures&#13;&#10;
                                        - Work in accordance with the organisation’s Integrated Management System (IMS)&#13;&#10;
                                        - Other tasks as directed"
                                    InputProps={{classes: {input: this.props.classes['input']}}}
                                />
                            </div>
                            <h4 style={{ paddingTop: "20px"}}>SKILLS & EXPERIENCE</h4>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    id="qualifications"
                                    name="qualifications"
                                    value={state.qualifications}
                                    label="Qualifications:"
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: "600px"}}
                                    placeholder="<What qualifications, licences or education level does the employee need?>&#13;&#10;
                                        e.g.&#13;&#10;
                                        - Diploma or Certificate IV in Business Admin or relevant experience&#13;&#10;
                                        - First aid certificate&#13;&#10;
                                        - Quality/safety/environment Lead Auditor training"
                                    InputProps={{classes: {input: this.props.classes['input']}}}
                                />
                            </div>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    id="experience"
                                    name="experience"
                                    value={state.experience}
                                    label="Experience:"
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: "600px"}}
                                    placeholder="<What type and how much experience is needed?>&#13;&#10;
                                        e.g. 3 years previous experience in an similar role/industry"
                                    InputProps={{classes: {input: this.props.classes['input']}}}
                                />
                            </div>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    id="skills"
                                    name="skills"
                                    value={state.skills}
                                    label="Skills:"
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: "600px"}}
                                    placeholder="<List skills needed for the job, including any technical or interpersonal skills>&#13;&#10;
                                        e.g.&#13;&#10;
                                        - Intermediate to advanced Microsoft Office skills (Word, Excel, PowerPoint and Outlook)&#13;&#10;
                                        - Excellent verbal and written communication&#13;&#10;
                                        - Organised and able to meet deadlines"
                                    InputProps={{classes: {input: this.props.classes['input']}}}
                                />
                            </div>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    id="performanceGoals"
                                    name="performanceGoals"
                                    value={state.performanceGoals}
                                    label="PERFORMANCE GOALS:"
                                    multiline
                                    rows={8}
                                    onChange={this.handleTextChange}
                                    style={{ width: "600px"}}
                                    placeholder="<The level of performance you expect from the employee>&#13;&#10;
                                        e.g.&#13;&#10;
                                        - Complete administration tasks on time&#13;&#10;
                                        - Deal with clients, suppliers and other employees professionally at all times&#13;&#10;
                                        - Ensure office is clean and presentable at all times"
                                    InputProps={{classes: {input: this.props.classes['input']}}}
                                />
                            </div>
                            <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                <OrangeButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleTwoTone />}
                                    size="small"
                                    onClick={this.onCancel}
                                    style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                >
                                    CANCEL
                                </OrangeButton>
                                <GreenButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleTwoTone />}
                                    size="small"
                                    onClick={this.onSave}
                                    style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                >
                                    SAVE
                                </GreenButton>
                            </div>
                        </div>
                )}
            </Paper>
            <NotificationContainer/>
        </div>
    }
}

export default withStyles(classes)(PositionDescriptions);
